import { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import Earth from './Earth';
import Starfield from './Starfield';
import CameraRig from './CameraRig';

export default function SpaceScene({ mobile, active, reducedMotion }) {
  return (
    <div className="fixed inset-0 z-0" data-testid="space-scene" aria-hidden="true">
      <Canvas
        dpr={mobile ? [1, 1.5] : [1, 2]}
        camera={{ fov: 50, near: 0.1, far: 220, position: [0, 0.35, 11.2] }}
        gl={{ antialias: !mobile, powerPreference: 'high-performance' }}
        frameloop={active ? 'always' : 'demand'}
      >
        <color attach="background" args={['#030308']} />
        <fog attach="fog" args={['#030308', 40, 90]} />
        <Suspense fallback={null}>
          <ambientLight intensity={0.25} />
          <directionalLight position={[5, 2, 4]} intensity={3.0} color="#fff2e2" />
          <pointLight position={[-6, -2, -5]} intensity={1.4} color="#713BFF" />
          <Starfield mobile={mobile} reducedMotion={reducedMotion} />
          <Earth mobile={mobile} reducedMotion={reducedMotion} />
        </Suspense>
        <CameraRig reducedMotion={reducedMotion} />
      </Canvas>
    </div>
  );
}
